export default [
  {
    path: "/adminMenuIndex",
    component: () =>
      import(/* webpackChunkName: "admin" */ "@/views/admin/menu/index"),
    name: "adminMenuIndex",
    meta: {
      isTab: true,
      keepAlive: true,
      links: ["菜单管理"],
      permissionsPath: "/adminMenuIndex"
    }
  },
  {
    path: "/adminUserIndex",
    component: () =>
      import(/* webpackChunkName: "admin" */ "@/views/admin/user/index"),
    name: "/adminUserIndex",
    meta: {
      isTab: true,
      keepAlive: true,
      links: ["用户管理"],
      permissionsPath: "/adminUserIndex"
    }
  },
  {
    path: "/adminRoleIndex",
    component: () =>
      import(/* webpackChunkName: "admin" */ "@/views/admin/role/index"),
    name: "adminRoleIndex",
    meta: {
      isTab: true,
      keepAlive: true,
      links: ["角色管理"],
      permissionsPath: "/adminRoleIndex"
    }
  },
  {
    path: "/adminDeptIndex",
    component: () =>
      import(/* webpackChunkName: "admin" */ "@/views/admin/dept/index"),
    name: "adminDeptIndex",
    meta: {
      isTab: true,
      keepAlive: true,
      links: ["部门管理"],
      permissionsPath: "/adminDeptIndex"
    }
  },
  {
    path: "/adminLogIndex",
    component: () =>
      import(/* webpackChunkName: "admin" */ "@/views/admin/log/index"),
    name: "adminLogIndex",
    meta: {
      isTab: true,
      keepAlive: true,
      links: ["日志管理"],
      permissionsPath: "/adminLogIndex"
    }
  },
  {
    path: "/ifaceLogIndex",
    component: () =>
      import(/* webpackChunkName: "admin" */ "@/views/admin/ifacelog/index"),
    name: "ifaceLogIndex",
    meta: {
      isTab: true,
      keepAlive: true,
      links: ["流转接口日志"],
      permissionsPath: "/consignorSetting"
    }
  },
  {
    path: "/ladocumentsync",
    component: () =>
      import(
        /* webpackChunkName: "admin" */ "@/views/admin/ifacelog/ladocumentsync"
      ),
    name: "ladocumentsync",
    meta: {
      isTab: true,
      keepAlive: true,
      links: ["回销附件日志"],
      permissionsPath: "/consignorSetting"
    }
  },
  {
    path: "/ifacecasesync",
    component: () =>
      import(
        /* webpackChunkName: "admin" */ "@/views/admin/ifacelog/ifacecasesync"
      ),
    name: "ifacecasesync",
    meta: {
      isTab: true,
      keepAlive: true,
      links: ["案件同步日志"],
      permissionsPath: "/consignorSetting"
    }
  },
  {
    path: "/reqAndResLog",
    component: () =>
      import(
        /* webpackChunkName: "admin" */ "@/views/admin/ifacelog/reqAndResLog"
      ),
    name: "reqAndResLog",
    meta: {
      isTab: true,
      keepAlive: true,
      links: ["公估对接日志"],
      permissionsPath: "/reqAndResLog"
    }
  },
  {
    path: "/adminDictIndex",
    component: () =>
      import(/* webpackChunkName: "admin" */ "@/views/admin/dict/index"),
    name: "adminDictIndex",
    meta: {
      isTab: true,
      keepAlive: true,
      links: ["字典管理"],
      permissionsPath: "/adminDictIndex"
    }
  },
  {
    path: "/adminParamIndex",
    component: () =>
      import(/* webpackChunkName: "admin" */ "@/views/admin/param/index"),
    name: "adminParamIndex",
    meta: {
      isTab: true,
      keepAlive: true,
      links: ["参数管理"],
      permissionsPath: "/adminParamIndex"
    }
  },
  {
    path: "/adminEmailIndex",
    component: () =>
      import(/* webpackChunkName: "admin" */ "@/views/admin/email/index"),
    name: "adminEmailIndex",
    meta: {
      isTab: true,
      keepAlive: true,
      links: ["邮件模板配置"],
      permissionsPath: "/adminEmailIndex"
    }
  },
  {
    path: "/adminNetworkIndex",
    component: () =>
      import(/* webpackChunkName: "admin" */ "@/views/admin/network/index"),
    name: "adminNetworkIndex",
    meta: {
      isTab: true,
      keepAlive: true,
      links: ["网关路由配置"],
      permissionsPath: "/adminNetworkIndex"
    }
  },
  {
    path: "/adminLoginLog",
    component: () =>
      import(/* webpackChunkName: "admin" */ "@/views/admin/log/login"),
    name: "adminLoginLog",
    meta: {
      isTab: true,
      keepAlive: false,
      links: ["登录日志"],
      permissionsPath: "/adminLoginLog"
    }
  }
];
